export default __webpack_public_path__ + "static/divisabg-faac52fdc65aec338d20b9255da44d8b.png";